import React, { useEffect, useState } from 'react';
import GlitchText from './GlitchText';

const ComingSoon = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const section = document.getElementById('coming-soon');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section 
      id="coming-soon"
      className="coming-soon-section" 
      data-testid="coming-soon-section"
    >
      {/* Large Background Text */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none">
        <span 
          className={`font-heading font-black text-[20vw] text-white/[0.03] uppercase tracking-tighter whitespace-nowrap transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
        >
          NEW ERA
        </span>
      </div>

      {/* Main Content */}
      <div className={`relative z-10 text-center transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Glitch Text Effect */}
        <h2 
          className="font-heading font-black text-5xl md:text-7xl lg:text-8xl text-white tracking-tighter mb-6"
          data-testid="coming-soon-title"
        >
          <GlitchText alwaysActive>THE NEXT CHAPTER</GlitchText>
        </h2>
        
        {/* Coming Soon Badge */}
        <div 
          className={`inline-flex items-center gap-3 border border-white/20 px-6 py-3 transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
          data-testid="coming-soon-badge"
        >
          <span className="w-2 h-2 bg-white/80 rounded-full animate-pulse-slow" />
          <span className="font-mono text-sm tracking-[0.3em] uppercase text-white/80">
            <GlitchText>Coming Soon</GlitchText>
          </span>
        </div>

        {/* Subtitle */}
        <p 
          className={`font-mono text-xs tracking-[0.2em] uppercase text-white/40 mt-8 transition-all duration-1000 delay-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
          data-testid="coming-soon-subtitle"
        >
          <GlitchText>New Album In Progress</GlitchText>
        </p>
      </div>

      {/* Decorative Lines */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
    </section>
  );
};

export default ComingSoon;
